export default "__VITE_ASSET__D2jFyLxq__"